import { FC, useEffect, useState } from 'react';
import { Box, Modal as QcsModal } from '@mui/material';

import { QcsModalBox } from '../../../common/basic/QcsModalBox';
import { QcsTypography } from '../../../common/basic/QcsTypography';
import { getFirstLastNameObj } from '../../../../utils/format';
import { invitationHistoryListActions } from '../../../../store/entities/invitationHistoryList';
import { useInvitation } from './invitationFunctions';
import { QcsClickToCopyText } from '../../../common/basic/QcsClickToCopyText';
import { SupplierEmployeeDto } from '@api/models/suppliers/SupplierEmployeeDto';
import { InvitedPersonDto } from '@api/models/invitation/InvitedPersonDto';
import { supplierEmployeeService } from '@api/services/services';
import { ShowError } from '../../../ShowError';
import { resources } from '@api/resources';
import { ShowResourceContent } from '../../../ShowResourceContent';

interface Props {
  invitedPerson?: InvitedPersonDto | SupplierEmployeeDto;
  onClose: () => void;
}

/** Supplier employee id of an invited person, whichever of the two shapes it arrives in. */
export function getEmployeeId(person: InvitedPersonDto | SupplierEmployeeDto): string {
  if ('employeeId' in person && typeof person.employeeId === 'string' && !!person.employeeId) {
    return person.employeeId;
  }
  return person.id ?? '';
}

export const InvitedPersonsPinModal: FC<Props> = ({ invitedPerson, onClose }) => {
  const { t, invitation, dispatch } = useInvitation();

  const [pin, setPin] = useState('');

  useEffect(() => {
    (async () => {
      if (!invitedPerson) return;

      setPin('');
      const pin = await supplierEmployeeService.revealPin(getEmployeeId(invitedPerson), invitation.id!);
      setPin(pin.data.pin!);
      dispatch(invitationHistoryListActions.reload(true));
    })();
  }, [dispatch, invitation.id, invitedPerson]);

  return (
    <QcsModal open={!!invitedPerson} onClose={onClose}>
      <QcsModalBox>
        <QcsTypography variant="h4" sx={{ mb: '1.5rem' }}>
          {t('invitation.persons.pinTitle')} {getFirstLastNameObj(invitedPerson)}:
        </QcsTypography>
        <ShowError resource={resources.revealPin} />
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
          <ShowResourceContent resource={resources.revealPin}>{pin && <QcsClickToCopyText text={pin} />}</ShowResourceContent>
        </Box>
      </QcsModalBox>
    </QcsModal>
  );
};
